/* session和localstorage操作工具函数 */

import { isDefined } from './util'
export function getSessionVal(key) {
  try {
    const value = window.sessionStorage[key]
    if (isDefined(value)) {
      return value
    }
    return ''
  } catch (e) {
    console.log('获取sessionStorage报错>>', e)
  }
}

export function setSessionVal(key, value) {
  try {
    window.sessionStorage[key] = value
  } catch (e) {
    console.log('设置sessionStorage报错>>', e)
  }
}
export function clearSessionVal(key) {
  try {
    if (key) window.sessionStorage.removeItem(key)
    else window.sessionStorage.clear()
  } catch (e) {
    this.clearCookie(key)
  }
}

// export function setLocVal(key, value) {
//   try {
//     window.localStorage[key] = value
//   } catch (err) {
//     clearLocVal(key)
//     document.cookie = key + '=' + escape(value) + ';'
//   }
// }

export function getLocVal(key) {
  try {
    window.localStorage['1'] = 1
    const value = window.localStorage[key]
    return value
  } catch (e) {
    let cStart = document.cookie.indexOf(key + '=')
    if (cStart != -1) {
      cStart = cStart + key.length + 1
      let cEnd = document.cookie.indexOf(';', cStart)
      if (cEnd == -1) {
        cEnd = document.cookie.length
      }
      return unescape(document.cookie.substring(cStart, cEnd))
    }
  }
}

// export function clearLocVal(key) {
//   try {
//     if (key) window.localStorage.removeItem(key)
//     else window.localStorage.clear()
//   } catch (e) {
//     if (key) {
//       const exp = new Date()
//       exp.setTime(exp.getTime() - 1)
//       const cval = getCookie(key)
//       if (cval != null) {
//         document.cookie = key + '=' + cval + ';expires=' + exp.toGMTString()
//       }
//     } else {
//       const keys = document.cookie.match(/[^=;]+(?=\=)/g)
//       if (keys) {
//         for (let i = keys.length; i >= 0; i--) {
//           document.cookie = keys[i] + '=0;expires=' + new Date(0).toGMTString()
//         }
//       }
//     }
//   }
// }
